module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": _vm.showDialog
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticStyle: {}
  }, [_vm._v("\n       = 'all-trains'\n      v-model = '\n    />\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c5479b7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/trainRecord/trainModal.vue
// module id = 948
// module chunks = 2